import './quote-assessment.css';

/**
 * The two answers warehouse staff gave when they created this OP quote (spec
 * docs/archive/202610/specs_20261019_op-quote-routing.md). They decide what Quote Ready does,
 * so the reviewer sees that before pressing it.
 *
 * Nothing for a non-OP quote, or for an OP quote created before the questions
 * existed (both answers null): there is nothing to say about either.
 */
export default function OpAnswersPanel({ deal }) {
    if (deal?.channel !== 'operator') return null;
    if (deal.item_with_us == null && deal.price_agreed == null) return null;
    return (
        <section className="qa-customer-note card" aria-label="Warehouse answers">
            <div className="qa-lab">Warehouse answers</div>
            <div className="qa-note-text">
                {deal.item_with_us
                    ? 'Item is with us. Quote Ready books a warehouse drop-off. No email is sent.'
                    : 'Item is with the customer. Quote Ready emails the offer.'}
            </div>
            {deal.price_agreed && (
                <div className="qa-note-text">
                    <strong>Price agreed with the customer. It is final: Prism applies it at every grade.</strong>
                </div>
            )}
        </section>
    );
}
